<template>
    <div class="my-6 mb-12">
        <v-navigation-drawer
            v-model="fileUploadDialog"
            temporary
            absolute
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow">
            <v-card tile class="drawer-content pb-12" elevation="0">
                <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                         {{ showReuploadMessage ? 'Replace Resource File' : 'Upload Resource Files' }}
                    </div>
                    <div class="d-inline">
                        <v-btn 
                            icon
                            outlined
                            color="info"
                            elevation="1"
                            @click="closeResourceUploads">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text class="pt-3">
                    <UploadResourceFiles 
                        :moduleId="moduleDetails.module_id"
                        :showReuploadMessage="showReuploadMessage"
                        :replaceDoc="showReuploadMessage ? resource_doc_args : null"
                        @closeResourceUploads="closeResourceUploads"
                        @refreshDocs="refreshDocs"
                    />
                </v-card-text>
            </v-card>
        </v-navigation-drawer>

        <v-navigation-drawer
            v-model="editResourceDialog"
            temporary
            absolute
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow">
            <v-card tile class="drawer-content pb-12" elevation="0">
                <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                         Edit Resource Document
                    </div>
                    <div class="d-inline">
                        <v-btn 
                            icon
                            outlined
                            color="info"
                            elevation="1"
                            @click="editResourceDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text class="my-3">
                    <v-row class="align-center">
                        <v-col cols="4">
                            <div class="mr-4">Client Label:</div>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                v-model="resource_doc_args.client_label"
                                outlined
                                dense
                                hide-details>

                                <template v-slot:append-outer>
                                   ({{ fileTypeText(resource_doc_args.type) }})
                                </template>
                                
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="align-center">
                        <v-col cols="4">
                            <div class="mr-4">Admin Label:</div>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                v-model="resource_doc_args.admin_label"
                                outlined
                                dense
                                hide-details>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="align-top">
                        <v-col cols="4">
                            <div class="mr-4">Description:</div>
                        </v-col>
                        <v-col cols="8">
                            <v-textarea
                                v-model="resource_doc_args.description"
                                outlined
                                dense
                                hide-details>
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-row class="align-center">
                        <v-col cols="4">
                            <div class="mr-4 d-flex align-center">
                                <div class="d-inline">Default Visibility:</div>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            class="d-inline ml-1"
                                            color="primary">
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <div style="width: 290px" v-html="default_visibility_tooltip"></div>
                                </v-tooltip>
                            </div>
                        </v-col>
                        <v-col cols="8">
                            <v-switch
                                v-model="resource_doc_args.default_visibility"
                                :label="resource_doc_args.default_visibility ? 'Visible' : 'Hidden'"
                                color="primary darken-1">
                            </v-switch>
                        </v-col>
                    </v-row>
                    <v-row class="align-center">
                        <v-col cols="4">
                            <div class="mr-4 d-flex align-center">
                                <div class="d-inline">Overview Visibility:</div>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            class="d-inline ml-1"
                                            color="primary">
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <div style="width: 290px" v-html="overview_visibility_tooltip"></div>
                                </v-tooltip>
                            </div>
                        </v-col>
                        <v-col cols="8">
                            <v-switch
                                v-model="resource_doc_args.overview_visibility"
                                :label="resource_doc_args.overview_visibility ? 'Visible' : 'Hidden'"
                                color="primary darken-1">
                            </v-switch>
                        </v-col>
                    </v-row>
                    <v-row class="align-center">
                        <v-col cols="4">
                            <div class="mr-4">Active in This Module:</div>
                        </v-col>
                        <v-col cols="8">
                            <v-switch
                                v-model="resource_doc_args.is_active"
                                :label="resource_doc_args.is_active ? 'Active' : 'Inactive'"
                                :disabled="!resource_doc_args.doc_is_active"
                                :hint="!resource_doc_args.doc_is_active ? 'Turn on Active in All Modules first' : ''"
                                persistent-hint
                                color="primary darken-1">
                            </v-switch>
                        </v-col>
                    </v-row>
                    <v-row class="align-center">
                        <v-col cols="4">
                            <div class="mr-4 d-flex align-center">
                                <div class="d-inline">Active in All Modules:</div>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            class="d-inline ml-1"
                                            color="primary">
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <div style="width: 290px" v-html="doc_is_active_tooltip"></div>
                                </v-tooltip>
                            </div>
                        </v-col>
                        <v-col cols="8">
                            <v-switch
                                v-model="resource_doc_args.doc_is_active"
                                :label="resource_doc_args.doc_is_active ? 'Active' : 'Inactive'"
                                color="primary darken-1"
                                @change="handleDocActiveChange">
                            </v-switch>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>
                    <v-row class="align-center">
                        <v-col cols="6" class="pb-1 mt-2">
                            ReUpload file to edit the file itself
                        </v-col>
                        <v-col cols="6" class="d-flex justify-end pt-0 pb-1">
                            <v-checkbox
                                v-model="find_and_copy"
                                label="Copy to all modules using this resource"
                                color="primary"
                                class="mt-4 pt-1"
                                hide-details>
                            </v-checkbox>
                        </v-col>
					</v-row>
                    <v-row class="align-center mb-n4">
                        <v-col cols="6" class="py-1">
                            <v-btn
                                class="px-11"
                                color="primary lighten-1 info--text"
                                outlined
                                @click="editResourceDialog = false; fileUploadDialog = true; showReuploadMessage = true;">
                                ReUpload File
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-end py-1">
                            <!-- <v-btn
                                outlined
                                color="primary"
                                class="mr-4"
                                @click="editResourceDialog = false">
                                close
                            </v-btn> -->
                            <v-btn
                                color="primary lighten-2 info--text"
                                @click="saveResDocChanges( resource_doc_args )">
                                save
                            </v-btn>
                        </v-col>
                    </v-row>
				</v-card-text>
			</v-card>
        </v-navigation-drawer>

        <v-navigation-drawer 
            v-model="deleteDialog" 
            temporary
            absolute
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow"
            :persistent="deleting"
        >
            <v-card v-if="delete_doc_args" tile class="drawer-content pb-12" elevation="0">
                <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                         Delete Resource
                    </div>
                    <div class="d-inline">
                        <v-btn 
                            icon
                            outlined
                            color="info"
                            elevation="1"
                            @click="deleteDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>

                <v-card-text class="pt-5">
                    <div class="mb-4 sansation font-weight-medium">
                        Are you sure you want to delete <strong>{{ delete_doc_args.admin_label }}</strong> ({{ delete_doc_args.client_label }})?
                    </div>

                    <div v-if="loading_usage" class="text-center py-6">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </div>

                    <template v-else>
                        <div class="mb-1 mt-9 sansation">Delete the file from:</div>
                        <v-radio-group v-model="delete_scope" hide-details class="mt-0 mb-4">
                            <v-radio :label="`Just this module (${projectSplit(delete_usage.module_project_count, delete_usage.module_all_project_count)})`" value="module"></v-radio>
                            <v-radio :label="`All modules that use it (${pluralize(delete_doc_args.module_count, 'module')}; ${projectSplit(delete_usage.project_count, delete_usage.all_project_count)})`" value="all_modules"></v-radio>
                        </v-radio-group>
                        <ul v-if="delete_scope != 'module'" class="mt-n2 mb-4 ml-8">
                            <li v-for="module_name in delete_doc_args.module_names" :key="module_name">{{ module_name }}</li>
                        </ul>

                        <template v-if="delete_scope != 'module'">
                            <div class="mb-1 mt-9 sansation">Also remove the file from storage (S3)?</div>
                            <v-radio-group v-model="delete_from_storage" hide-details class="mt-0 mb-4">
                                <v-radio label="No, keep the file in storage" :value="false"></v-radio>
                                <v-radio label="Yes, permanently delete the file from storage" :value="true"></v-radio>
                            </v-radio-group>
                        </template>

                        <div v-if="deletingFromStorage && delete_usage.all_project_count" class="mt-6 sansation">
                            The file will also be removed from all {{ projectSplit(delete_usage.project_count, delete_usage.all_project_count) }} that have it, since it will no longer exist.
                        </div>
                        <template v-else-if="affectedAllProjectCount && !deletingFromStorage">
                            <div class="mb-1 mt-9 sansation">
                                The file is on {{ projectSplit(affectedProjectCount, affectedAllProjectCount) }}. 
                                Remove it from {{ affectedAllProjectCount == 1 ? 'that project' : 'all of them' }} too?
                            </div>
                            <v-radio-group v-model="delete_keep_projects" hide-details class="mt-0 mb-4">
                                <v-radio :label="`Yes, remove it from ${affectedAllProjectCount == 1 ? 'the' : 'all'} ${projectSplit(affectedProjectCount, affectedAllProjectCount)}`" :value="false"></v-radio>
                                <v-radio label="No, keep it on existing projects (new projects won't get it)" :value="true"></v-radio>
                            </v-radio-group>
                        </template>

                        <div class="error--text sansation font-weight-medium mt-9">{{ deleteSummary }}</div>
                    </template>
                    <div v-if="delete_error" class="error--text sansation mt-3">{{ delete_error }}</div>
                </v-card-text>

                <v-card-actions class="mt-8 px-4 justify-end">
                    <v-btn 
                        text 
                        :disabled="deleting" 
                        @click="deleteDialog = false">
                        Cancel
                    </v-btn>
                    <v-btn 
                        color="primary lighten-2" 
                        class="info--text" 
                        elevation="1" 
                        :loading="deleting" 
                        :disabled="loading_usage" 
                        @click="deleteResource">
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-navigation-drawer>

        <div class="d-flex d-block align-center">
            <div class="sansation label_medium info--text d-inline">Module Resources</div>            
            <v-btn
                icon
                x-small
                class="ml-3 mt-n1 primary--text text--darken-1 d-inline"
                :style="refresh_docs ? 'border:none' : 'border:1px solid #3b9ba7'"
                :loading="refresh_docs"
                @click="refreshDocs()">
                <v-icon v-if="!refresh_docs"
                    small
                    class="primary--text text--darken-1">
                    mdi-autorenew
                </v-icon>
            </v-btn>
            <div class="d-inline ml-7 info--text">{{ fileCountText }}</div>
            <v-spacer></v-spacer>
            <div class="d-inline">
                <v-btn
                    small
                    class="ml-6 d-inline menu_bg_primary primary--text text--darken-1"
                    elevation=0
                    @click="fileUploadDialog = true">
                    Upload Resources Files
                    <v-icon small color="primary" class="ml-2" right>mdi-cloud-upload</v-icon>
                </v-btn>
            </div>
        </div>

        <div v-if="!readyToLoadDocs" class="text-center py-12 my-12" style="width: 100%">
			<v-progress-circular
				indeterminate 
				color="error darken-3" 
				class="my-12 py-12" 
				size="100" 
				width="8">
			</v-progress-circular>
		</div>
		
		<div v-else>
            <v-data-table
                v-if="readyToLoadDocs && module_resource_data.length"
                :headers="resources_header"
                :items="module_resource_data"
                :loading="refresh_docs"
                disable-pagination
                hide-default-header
                hide-default-footer
                class="mt-3">

                <template v-slot:header="{ props }">
                    <thead>
                        <tr class="justify-space-between">
                            <th v-for="header in props.headers" :key="header.value" style="padding: 0 .25rem !important">
                                <div class="d-inline">{{ header.text }}</div>
                                <v-tooltip v-if="header.tooltip" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            class="d-inline"
                                            color="primary">
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <div v-html="header.tooltip"></div>
                                </v-tooltip>
                            </th>
                        </tr>
                    </thead>
                </template>

                <template v-slot:body="{ items }">
                    <tbody name="list" is="transition-group" tag="tbody">
                        <tr v-for="(item, index) in items" 
                            :key="item.file_id" 
                            class="avenir_book"
                            
                            :draggable="true"
                            @dragstart="handleDragStart($event, index)"
                            @dragenter="handleDragEnter(index)"
                            @drop="handleDrop($event)"
                            @dragover.prevent
                            @dragend="handleDragEnd($event)">

                            <td width="3%" class="text-gray-500 handle-icon cell_padding cursor_pointer">
                                <v-icon small class="handle-icon">mdi-drag</v-icon>
                                {{ index + 1 }}
                            </td>

                            <td width="20%" class="cell_padding cursor_pointer">
                                <a v-if="!item.type.includes('video')" :href="item.url" class="clean_link" target="_blank">{{ item.client_label }}</a>
                                <a v-else @click="openVideo( { fileid: item.file_id, url: item.url, title: item.client_label, type: item.type, access: 'resource_docs' } )">{{ item.client_label }}</a>    
                                <div v-if="item.is_retired" class="mt-1">
                                    <v-chip x-small color="warning" text-color="white" title="Existing projects keep this file; new projects don't get it">Retired</v-chip>
                                    <v-btn x-small text color="primary" class="ml-1" @click.stop="restoreResource(item)">
                                        <v-icon x-small left>mdi-restore</v-icon>Restore
                                    </v-btn>
                                </div>
                            </td>

                            <td width="20%" @click="openResDetailsDialog(item)" class="cell_padding cursor_pointer">{{ item.admin_label }}</td>
                            
                            <td v-html="item.description" @click="openResDetailsDialog(item)" class="cell_padding cursor_pointer"></td>
                            
                            <td width="4%" @click="openResDetailsDialog(item)" class="cell_padding cursor_pointer">
                                {{ fileTypeText(item.type) }}
                            </td>
                            
                            <td width="8%" @click="openResDetailsDialog(item)" class="cell_padding cursor_pointer">
                                {{ item.default_visibility ? 'Visible' : 'Hidden' }}
                            </td>
                            
                            <td width="10%" @click="openResDetailsDialog(item)" class="cell_padding cursor_pointer">
                                {{ item.overview_visibility ? 'Visible' : 'Hidden' }}
                            </td>
                            
                            <td width="2%" @click="openResDetailsDialog(item)" class="text-center cell_padding cursor_pointer">
                                <v-icon 
                                    :color="item.is_active && item.doc_is_active ? 'primary' : 'error'"
                                    :title="item.doc_is_active ? '' : 'Inactive in all modules'">
                                    {{ item.is_active && item.doc_is_active ? 'mdi-check' : 'mdi-close' }}
                                </v-icon>
                            </td>

                            <td width="2%" class="text-center cell_padding">
                                <v-btn
                                    icon
                                    small
                                    color="error"
                                    title="Delete this resource"
                                    @click.stop="openDeleteDialog(item)">
                                    <v-icon small>mdi-trash-can-outline</v-icon>
                                </v-btn>
                            </td>
                        </tr>                    
                    </tbody>
                </template>
            </v-data-table>
            <div v-else-if="readyToLoadDocs && !module_resource_data.length" class="sansation label_medium info--text mt-3">No resources available</div>
        </div>
    </div>
</template>


<script>  
    import axios from "axios";
	import Cookie from 'js-cookie';
	import appUrls from '../helpers/environment';
    import dateFormat, { masks } from "dateformat";

    import UploadResourceFiles from './UploadResourceFiles'

    export default {
        name: 'ModuleResources',

        components: {
            UploadResourceFiles
        },

        props: {
            moduleDetails: Object,
            toggleVisiblity: Function,
            playResourceVideo: Function,
        },

        watch: {
            refresh_docs (val) {
                this.refresh_docs = val;
            }
        },

        computed: {
            deletingFromStorage () {
                return this.delete_scope != 'module' && this.delete_from_storage
            },

            // ACTIVE PROJECTS THE SELECTED OPTION AFFECTS (SHOWN FIRST)
            affectedProjectCount () {
                return this.delete_scope == 'module' ? this.delete_usage.module_project_count : this.delete_usage.project_count
            },

            // EVERY PROJECT THE SELECTED OPTION AFFECTS - REMOVING THE FILE FROM PROJECTS APPLIES TO ALL OF THEM, ACTIVE OR NOT
            affectedAllProjectCount () {
                return this.delete_scope == 'module' ? this.delete_usage.module_all_project_count : this.delete_usage.all_project_count
            },

            // RETIRE (KEEP ON EXISTING PROJECTS) ONLY APPLIES IF PROJECTS HAVE THE FILE & IT ISN'T BEING DELETED FROM STORAGE
            deleteKeepsProjects () {
                return this.delete_keep_projects && !!this.affectedAllProjectCount && !this.deletingFromStorage
            },

            deleteSummary () {
                const projects = this.projectSplit(this.affectedProjectCount, this.affectedAllProjectCount)
                if ( this.deletingFromStorage ) return `The file will be removed from every module that uses it and ${projects}, and permanently deleted from storage. This cannot be undone.`
                const where = this.delete_scope == 'module' ? 'this module' : 'every module that uses it'
                if ( this.deleteKeepsProjects ) return `The file will be retired from ${where}. The ${projects} keep it, new projects won't get it. It can be restored from the table.`
                return `The file will be removed from ${where}${this.affectedAllProjectCount ? ` and ${projects}` : ''}.${this.delete_scope == 'module' ? ' Other modules using it are not affected.' : ' It will stay in storage.'}`
            },

            fileCountText () {
                return `${this.module_resource_data.length} file${this.module_resource_data.length == 1 ? '':'s'}`
            }
        },

        data () {
            return {
                refresh_docs: false,
                fileUploadDialog: false,
                editResourceDialog: false,
                deleteDialog: false,
                delete_doc_args: null,
                delete_scope: 'module',
                delete_from_storage: false,
                delete_keep_projects: false,
                delete_usage: { module_project_count: 0, module_all_project_count: 0, project_count: 0, all_project_count: 0 },
                loading_usage: false,
                delete_error: '',
                deleting: false,
                showReuploadMessage: false,
                readyToLoadDocs: false,
                find_and_copy: false,
                module_resource_data: [],
                resource_doc_args: {},
                default_visibility_tooltip: 'These are files and/or videos that will show up in the lower Resource Documents area of the client&apos;s Roadmap page, when toggled on.',
                doc_is_active_tooltip: 'Master switch for the file itself. Turning it off makes the file inactive in every module using it. Turning it back on does not reactivate the other modules; each one is switched on individually.',
                overview_visibility_tooltip: 'These are files and/or videos that will show up within the text of the client&apos;s roadmap step description, when toggled on.',
                
                dragItemIndex: null,
                dragOverItemIndex: null,
                
                resources_header: [   
                    {   text: 'Order', 
                        value: 'sort_order', 
                        sortable: false, 
                        width: '3%' 
                    },
                    {   text: 'Client Label',     
                        value: 'client_label',    
                        align: 'start',  
                        sortable: true, 
                        width: '20%' 
                    },
                    {   text: 'Admin Label',     
                        value: 'admin_label',    
                        align: 'start',  
                        sortable: true, 
                        width: '20%' 
                    },
                    {   text: 'Description',     
                        value: 'description',
                        align: 'start',    
                        sortable: true
                    },
                    {   text: 'File Type',     
                        value: 'type',
                        align: 'start',
                        sortable: true,
                        width: '4%'
                    },
                    {   text: 'Default Visibility',     
                        value: 'default_visibility',
                        tooltip: 'These are files and/or videos that will show up in the lower Resource Documents area of the client&apos;s Roadmap page, when toggled on.',
                        align: 'end',  
                        sortable: true,
                        width: '8%'
                    },
                    {   text: 'Default Stage Visibility',     
                        value: 'overview_visibility',
                        tooltip: 'These are files and/or videos that will show up within the text of the client&apos;s roadmap step description, when toggled on.',
                        align: 'end',
                        sortable: true,
                        width: '10%'
                    },
                    {   text: 'Active',
                        value: 'is_active',
                        align: 'end',    
                        sortable: true,
                        width: '2%'
                    },
                    {   text: 'Delete',
                        value: 'delete',
                        align: 'center',
                        sortable: false,
                        width: '2%'
                    }
                ]
            }
        },
        
        methods: {    
            getResourceDocInfo: async function () {
				try {
					const resource_docs_rs = await axios.post(`${appUrls.api}/api/admin/module_resources/${this.moduleDetails.module_id}`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        purpose: 'manage_module_resources'
					})

					if( resource_docs_rs.data.outcome ){
						this.module_resource_data = resource_docs_rs.data.resource_info
                        this.refresh_docs = false
                        this.readyToLoadDocs = true
						// this.triggerUserFeedback( true, resource_docs_rs.data.message );
					} else {
						// this.triggerUserFeedback( true, resource_docs_rs.data.message );
					}

				} catch ( error ) {
					console.log(error);
				}
            },

            closeResourceUploads: function () {
                this.fileUploadDialog = false
                this.showReuploadMessage = false
            },

            openResDetailsDialog: function ( item ) {
                // EDIT A COPY SO UNSAVED CHANGES DON'T SHOW IN THE TABLE
                this.resource_doc_args = { ...item }
                this.editResourceDialog = true;
            },

            handleDocActiveChange: function ( doc_is_active ) {
                // MIRRORS THE DB CASCADE - A FILE THAT IS OFF IN ALL MODULES IS ALSO OFF IN THIS ONE
                if ( !doc_is_active ) this.resource_doc_args.is_active = false
            },

            refreshDocs: function () {
                this.refresh_docs = true
                setTimeout(() => { 
                    this.getResourceDocInfo()
                }, 1000)
            },

            openVideo ( data ) {
                this.$emit('playResourceVideo', data )
            },

            pluralize: function ( count, word ) {
                return `${count || 0} ${word}${count == 1 ? '' : 's'}`
            },

            // PROJECT COUNT SPLIT INTO ACTIVE & INACTIVE/TEST - e.g. "3 projects (2 active, 1 inactive/test)"
            projectSplit: function ( active, total ) {
                active = active || 0
                total = total || 0
                if ( !total ) return 'no projects'
                return `${this.pluralize(total, 'project')} (${active} active, ${total - active} inactive/test)`
            },

            openDeleteDialog: async function ( item ) {
                this.delete_doc_args = item
                this.delete_scope = 'module'
                this.delete_from_storage = false
                this.delete_keep_projects = false
                this.delete_error = ''
                this.deleteDialog = true

                // HOW MANY EXISTING PROJECTS HAVE THIS FILE
                this.loading_usage = true
                try {
                    const usage_rs = await axios.post(`${appUrls.api}/api/admin/module_resource_usage`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        module_id: this.moduleDetails.module_id,
                        doc_id: item.file_id
                    })
                    this.delete_usage = usage_rs.data.outcome ? usage_rs.data.usage : { module_project_count: 0, module_all_project_count: 0, project_count: 0, all_project_count: 0 }
                } catch ( error ) {
                    console.log(error)
                    this.delete_error = 'The number of projects using this file could not be loaded.'
                } finally {
                    this.loading_usage = false
                }
            },

            deleteResource: async function () {
                this.deleting = true
                this.delete_error = ''
                try {
                    const scope = this.delete_scope == 'module' ? 'module' : this.delete_from_storage ? 'storage' : 'all_modules'
                    const delete_rs = await axios.post(`${appUrls.api}/api/admin/delete_module_resource`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        module_id: this.moduleDetails.module_id,
                        doc_id: this.delete_doc_args.file_id,
                        scope,
                        keep_projects: this.deleteKeepsProjects
                    })

                    if ( delete_rs.data.outcome ) {
                        this.deleteDialog = false
                        this.refreshDocs()
                    } else {
                        this.delete_error = delete_rs.data.message
                    }
                } catch ( error ) {
                    console.log(error)
                    this.delete_error = 'There was a problem deleting this resource.'
                } finally {
                    this.deleting = false
                }
            },

            restoreResource: async function ( item ) {
                try {
                    const restore_rs = await axios.post(`${appUrls.api}/api/admin/restore_module_resource`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        resource_to_module_id: item.resource_to_module_id
                    })
                    if ( restore_rs.data.outcome ) this.refreshDocs()
                } catch ( error ) {
                    console.log(error)
                }
            },

            saveResDocChanges: async function ( data ) {
                try {
					const resource_doc_rs = await axios.post(`${appUrls.api}/api/admin/update_module_resource`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
						resource_data: data,
                        find_and_copy: this.find_and_copy
					})

    				data = resource_doc_rs.data.resource_data

                    this.editResourceDialog = false
                    this.refreshDocs()

				} catch ( error ) {
					console.log(error);
				}
            },
            
            fileTypeText: function ( type ) {
                if ( !type ) return 'N/A'
                if ( type.includes('pdf') ) return 'PDF'
                if ( type.includes('doc') || type.includes('word') ) return 'Word'
                if ( type.includes('xls') || type.includes('excel') ) return 'Excel'
                if ( type.includes('ppt') || type.includes('powerpoint') ) return 'PowerPoint'
                if ( type.includes('mp4') || type.includes('quicktime') || type.includes('video') ) return 'Video'
                return 'File'
            },

            formatDate: function ( date, mask ) {
                return dateFormat(date, mask)
            },

            handleDragStart: function (event, index) {
                this.dragItemIndex = index; 
                event.dataTransfer.effectAllowed = 'move';
                event.currentTarget.classList.add('dragging');
            },

            handleDragEnter: function (index) {
                this.dragOverItemIndex = index;
            },

            handleDragEnd: function (event) {
                event.currentTarget.classList.remove('dragging');
            },

            handleDrop: function (event) {
                event.preventDefault();
                
                const sourceIndex = this.dragItemIndex;
                const targetIndex = this.dragOverItemIndex;

                if (sourceIndex === null || targetIndex === null || sourceIndex === targetIndex) {
                    this.dragItemIndex = null;
                    this.dragOverItemIndex = null;
                    return;
                }

                const newDocuments = this.module_resource_data.slice(); 
                const [movedItem] = newDocuments.splice(sourceIndex, 1);
                newDocuments.splice(targetIndex, 0, movedItem);

                this.module_resource_data = newDocuments; 

                const reorderPayload = newDocuments.map((doc, index) => ({
                    file_id: doc.file_id,
                    sort_order: index + 1
                }));

                this.saveResourceOrder(reorderPayload);

                this.dragItemIndex = null;
                this.dragOverItemIndex = null;
            },

            saveResourceOrder: async function (reorderPayload) {
                try {
                    const reorder_rs = await axios.post(`${appUrls.api}/api/admin/update_module_resources_order`, { 
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        module_id: this.moduleDetails.module_id,
                        resource_order: reorderPayload // [{ file_id, sort_order }, ...]
                    });

                    if( reorder_rs.data.outcome ){
                         console.log("Sort order updated successfully via API.");
                    } else {
                         console.error("API failed to update sort order:", reorder_rs.data.message);
                    }
                } catch (error) {
                    console.error("Failed to commit batch update via API:", error);
                } finally {
                    this.refreshDocs();
                }
            }
        },

        mounted: async function () {
            await this.getResourceDocInfo()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table_body td {
        /* padding-top: .5rem !important; 
        padding-bottom: .5rem !important;
        vertical-align: top !important; */
    }
    tr:nth-of-type(even) {
        background-color: rgba(0, 0, 0, .05);
    }
    .handle-icon:hover {
        cursor: grab;
    }
    .table_body[draggable="true"] {
        cursor: grab;
    }
    .dragging {
        opacity: 0.5;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    }
    .cell_padding {
        padding: .75rem .25rem !important;
        vertical-align: top !important;
    }
    .cursor_pointer {
        cursor: pointer;
    }
    .clean_link {
        text-decoration: none;
    }
    .bg_pewter {
        background-color: #E9EAEC;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 2.5rem;
    }
    .icon-center {
        margin: 0 auto;
    }
    .drawer-shadow {
        position: fixed !important;
        top: 0 !important;
        right: 0 !important;
        height: 100vh !important;
        z-index: 2000;
        box-shadow: -6px 0 12px rgba(0, 0, 0, 0.15);
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
        background-color: whitesmoke !important;
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
</style>


// WEBPACK FOOTER //
// src/components/ModuleResources.vue